export default "__VITE_ASSET__CQW$ESnM__"